import type { IMaintenanceListResponse } from '@/store/api/maintenanceApi';

const ticketTime = (ticket: IMaintenanceListResponse): number => {
  const raw = ticket.updatedOn || ticket.createdOn;
  if (!raw) return 0;
  const ms = new Date(raw).getTime();
  return Number.isFinite(ms) ? ms : 0;
};

/**
 * The list's hero is the most recently touched OPEN request. Uses its own
 * comparator (updatedOn || createdOn, newest wins, first on ties) instead of
 * the global iOS-aligned list sort, which sinks tickets lacking updatedOn and
 * would demote a just-created request.
 */
export const pickHeroTicket = (
  openTickets: IMaintenanceListResponse[],
): IMaintenanceListResponse | undefined => {
  if (openTickets.length === 0) return undefined;
  return openTickets.reduce((best, ticket) =>
    ticketTime(ticket) > ticketTime(best) ? ticket : best,
  );
};
